























import { defineComponent, ref, toRefs, computed, watch, onMounted } from '@vue/composition-api';
import { CloseIcon } from 'tdesign-icons-vue';
export default defineComponent({
  components: {
    CloseIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    uploadPercent: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const percent = computed(() => props.uploadPercent);
    const methods = {
      cancelUpload() {
        context.emit('cancelUpload');
      },
    };
    return {
      innerShow,
      percent,
      ...methods,
    };
  },
});
